import React from "react";
import PropTypes from "prop-types";

// Pill styling is taken verbatim from the V2 Source Directory Figma tag component.
const pillStyle = {
  fontSize: 13,
  fontWeight: 500,
  lineHeight: "18.85px",
  color: "#212528",
  background: "#f5f9ff",
  padding: "5px 12px",
  borderRadius: 999,
  whiteSpace: "nowrap",
};

function tagName(tag) {
  return tag.hashtag_name || tag.hashtagName || tag;
}

function HashtagPills({ hashtags = [], max = 4 }) {
  const shown = (hashtags || []).slice(0, max);
  if (shown.length === 0) return null;

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
      {shown.map((tag) => (
        <span key={tag.hashtag_slug || tagName(tag)} style={pillStyle}>
          {tagName(tag)}
        </span>
      ))}
    </div>
  );
}

HashtagPills.propTypes = {
  hashtags: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        hashtag_name: PropTypes.string,
        hashtag_slug: PropTypes.string,
        hashtagName: PropTypes.string,
      }),
    ]),
  ),
  max: PropTypes.number,
};

export default HashtagPills;
